import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { createStyles as q, rem as M, Box as i, Group as O, Anchor as Q, Text as v } from "@mantine/core";
import { useMediaQuery as R } from "@mantine/hooks";
import { useCallback as z } from "react";
import { ProductBadge as E } from "../ProductBadge/index.js";
import "./ProductTileSkeleton.js";
import { Actions as F } from "./subcomponents/Actions.js";
import { Image as H } from "./subcomponents/Image.js";
import { Prices as J } from "./subcomponents/Prices.js";
import { Reviews as K } from "./subcomponents/Reviews.js";
import { SkuButtons as V } from "./subcomponents/SkuButtons.js";
import { SkuSelect as W } from "./subcomponents/SkuSelect.js";
const X = q((o) => ({
  container: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },
  link: {
    color: o.colors.black[4],
    "&:hover": {
      color: o.colors.black[4],
      textDecoration: "underline"
    }
  }
})), ae = ({ attributes: o, onAction: w, onSkuClick: t, onTileClick: m, product: l, showAdPrice: k = !0, showSkuSelector: d = !0 }) => {
  const { classes: p } = X(), u = R(`(max-width: ${M(767)})`) ? "select" : "buttons", { activeSku: s, badge: $, brand: f, brandlessName: h, imageAlt: B, imageUrl: N, link: x, review: { average: P, count: j }, skus: c = [] } = l, [A] = c, g = c.find(({ sku: a }) => a === s) ?? A, y = g.badge ?? $, { action: I, isSoldOut: S, price: D, quantityInCart: G, sku: n } = g, L = `${x}/${n.toLowerCase()}`, b = z(async ({ skuId: a, toggle: U = "more" }) => {
    t == null || t({
      type: a ? "sku" : U,
      value: a ?? n
    });
  }, [t, n]);
  return r(i, { className: p.container, ...o == null ? void 0 : o.container, children: [r(i, { children: [e(O, { h: "xl", mb: "xs", children: y && e(E, { style: y }) }), r(Q, { className: p.link, href: L, onClick: () => m == null ? void 0 : m(l), "data-sku": s, children: [e(H, { imageAlt: B, imageUrl: N, isSoldOut: S }), r(v, { fw: 400, component: "h4", lineClamp: 3, mb: "md", mih: 65, children: [e(v, { fw: 700, span: !0, children: f }), " ", h] })] }), e(K, { average: P, count: j, productLink: x }), d && u === "buttons" && e(V, { skus: c, activeSku: s, onSkuChange: b }), d && u === "select" && e(W, { skus: c, activeSku: s, onSkuChange: b })] }), r(i, { children: [e(J, { price: D, showAdPrice: k }), e(F, { onAction: w, action: I, sku: n, attributes: o, quantityInCart: G, productName: `${f} ${h}` })] })] });
};
export {
  ae as ProductTile
};
